import { format } from 'date-fns';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetWorkforceDistributionOperations } from '@/modules/home/apiHooks';
import { getMax } from '@/modules/home/components/PageContent/WorkforceSections/logic';
import { WorkforceDistributionRow } from '@/modules/home/components/PageContent/WorkforceSections/WorkforceDistribution/WorkforceDistributionRow';
import { useHomePageContext } from '@/modules/home/context';
import { EmptyCard } from '@/shared/components/molecules';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import Tractor from '~/images/shared/Tractor.svg';

function WorkforceDistributionOperations() {
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);
  const { data, mutate } = useGetWorkforceDistributionOperations();
  const {
    state: { date },
  } = useHomePageContext();

  useEffect(() => {
    if (selectedAsset?.id && date) {
      mutate({
        entityId: selectedAsset.id,
        date: format(date, 'yyyy-MM-dd'),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAsset?.id, date]);

  return data?.length ? (
    <div className='flex max-h-388 min-h-[300px] w-full flex-col gap-2 overflow-y-auto px-16'>
      {data?.map((item, idx) => (
        <WorkforceDistributionRow
          key={idx}
          item={item}
          totalCount={getMax(data) ?? 0}
          type='operations'
        />
      ))}
    </div>
  ) : (
    <EmptyCard
      directiveMessage={t('create-operation-and-workers')}
      message={t('no-workers-operations')}
      vector={
        <div className=' text-40 text-primary-60'>
          <Tractor />
        </div>
      }
      variant='icon'
      classeName='my-40 text-center px-40 max-w-1/2'
    />
  );
}

export { WorkforceDistributionOperations };
